export function isMobile() {
  const breakpoint = getComputedStyle(document.documentElement).getPropertyValue("--breakpoint-mobile")
  return matchMedia(`(max-width: ${breakpoint})`).matches
}
